import { Box, Typography } from '@mui/material';
import React from 'react';

const JukoBoxLogo: React.FC<{ size?: number; style?: React.CSSProperties }> = ({
  size = 80,
  style,
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Box
      component="img"
      src="/assets/img/logo.png"
      alt="Logo JukoBox - petite fille qui danse"
      sx={{ width: size, height: size, ...style }}
    />
    <Typography variant="h1" sx={{ fontWeight: 'bold', color: 'primary.main', fontSize: size / 2 }}>
      JukoBox
    </Typography>
  </Box>
);

export default JukoBoxLogo;
